export enum ServiceEventType {
  ApplyTreatment
}
